import { Theme } from "@emotion/react";
import { SxProps, TextField as MuiTextField } from "@mui/material";

interface TimeFieldProps {
  value: string | null;
  onChange: (value: string | null) => void;
  fullWidth?: boolean;
  stepSeconds?: number;
  sx?: SxProps<Theme>;
}

const defaultTimeFieldSx: SxProps<Theme> = {
  "& .MuiOutlinedInput-root": {
    borderRadius: "8px",
    height: 44,
    fontSize: 14,
    backgroundColor: "#fff",
    "& fieldset": { borderColor: "rgba(0,0,0,0.12)" },
  },
};

const toTimeOrNull = (value: string) => (value?.trim() ? value : null);

const TimeField = ({ value, onChange, fullWidth, stepSeconds, sx }: TimeFieldProps) => {
  return (
    <MuiTextField
      type="time"
      fullWidth={fullWidth}
      value={value ?? ""}
      onChange={(e) => onChange(toTimeOrNull(e.target.value))}
      inputProps={{ step: stepSeconds ?? 60 }}
      sx={{ ...defaultTimeFieldSx, ...sx }}
    />
  );
};

export default TimeField;